.insights {
  ul {
    display: flex;
    flex-flow: column nowrap;
    gap: var(--mantine-spacing-sm);
    align-items: start;
    padding: 0;
    margin-block: 0;
    list-style: none;
  }

  li {
    display: flex;
    gap: var(--mantine-spacing-xs);
    align-items: first baseline;
    .icon {
      flex: 1 0 auto;
      translate: 0 20%;
    }
    .insight-item {
      flex: 1 1 auto;
      p {
        display: inline;
      }
    }
  }

  .insight-item .marker {
    margin-inline-start: var(--mantine-spacing-xs);
    vertical-align: middle;
  }

  .insight {
    font-weight: 550;
    > div {
      display: inline;
    }
    strong,
    em {
      padding-block: 0;
      padding-inline: 0.4rem;
      font-weight: 700;
      background: alpha(var(--mantine-color-blue-9), 0.4);
      border-radius: var(--mantine-radius-sm);
    }
  }
}

.follow-up-questions {
  display: flex;
  flex-flow: row wrap;
  gap: calc(var(--mantine-spacing-xs) * 0.5);
}

.option-button {
  /* background: var(--mantine-color-dark-5); */
  box-shadow:
    0 0 1.4rem 0 transparent,
    inset 0 0 2rem 0 var(--mantine-color-dark-9);
  animation: action-pulse 8s ease-out infinite;
  animation-delay: calc(1s * var(--index));
}

@keyframes action-pulse {
  0%,
  100% {
    /* box-shadow: initial; */
    /* background: var(--mantine-color-dark-5); */
  }
  20% {
    box-shadow:
      0 0 1.4rem 0 alpha(var(--mantine-color-dark-4), 0.3),
      inset 0 0 2rem 0 var(--mantine-color-dark-3);
    /* background: color-mix(in oklab, var(--mantine-color-dark-4), var(--mantine-color-dark-5) 20%); */
  }
}

@keyframes glint-sweep {
  0% {
    background-position: 200% 100%;
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    background-position: 0% 0%;
    opacity: 0;
  }
}
